/**
 * @generated SignedSource<<59dcc5626af286b4fffde34f84dd1b03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type generateAppJwt_AuthViewerSchemaFragment$data = {
  readonly currentUser: {
    readonly accounts: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly user: {
      readonly id: string;
    };
  } | null;
  readonly " $fragmentType": "generateAppJwt_AuthViewerSchemaFragment";
};
export type generateAppJwt_AuthViewerSchemaFragment$key = {
  readonly " $data"?: generateAppJwt_AuthViewerSchemaFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"generateAppJwt_AuthViewerSchemaFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "generateAppJwt_AuthViewerSchemaFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrentUser",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Account",
          "kind": "LinkedField",
          "name": "accounts",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AuthViewerSchema",
  "abstractKey": null
};
})();

(node as any).hash = "614de151a01ca02dafe5ddb5f398f059";

export default node;
